module.exports = __webpack_public_path__ + "media/images/aloe/logo/nephos-f5840da30a5f5f881d7153d9ba790362.svg";